import { useQuery } from '@tanstack/react-query';
import { X } from 'lucide-react';
import { useState } from 'react';
import { api } from '../lib/api';

export function AppAnnouncementBanner() {
  const [dismissed, setDismissed] = useState(false);
  const { data } = useQuery({
    queryKey: ['public-announcement'],
    queryFn: () => api.getPublicAnnouncement(),
    staleTime: 120_000,
    refetchOnWindowFocus: true,
  });

  const ann = data?.announcement;
  if (dismissed || !ann?.message?.trim()) return null;

  const sev = ann.severity ?? 'info';
  const box =
    sev === 'error'
      ? 'border-red-300/90 bg-red-50 text-red-950 dark:border-red-900 dark:bg-red-950/50 dark:text-red-50'
      : sev === 'warning'
        ? 'border-amber-300/90 bg-amber-50 text-amber-950 dark:border-amber-900 dark:bg-amber-950/40 dark:text-amber-50'
        : 'border-primary/25 bg-primary/[0.08] text-text dark:border-primary/40';

  return (
    <div
      className={`print:hidden border-b px-4 py-2.5 text-sm ${box}`}
      role="status"
    >
      <div className="mx-auto flex max-w-6xl items-start gap-3 sm:items-center sm:px-2">
        <p className="min-w-0 flex-1 whitespace-pre-wrap [text-wrap:pretty]">{ann.message}</p>
        <button
          type="button"
          className="shrink-0 rounded-md p-1 opacity-70 hover:bg-black/5 hover:opacity-100 dark:hover:bg-white/10"
          aria-label="Melding sluiten (blijft zichtbaar na verversen)"
          onClick={() => setDismissed(true)}
        >
          <X className="h-4 w-4" aria-hidden />
        </button>
      </div>
    </div>
  );
}
